// `rawJSON` wraps a digit string so `JSON.stringify` emits it verbatim.
// Typed by `src/core-js-raw-json.d.ts` until TypeScript ships the API.
import rawJSON from "core-js/actual/json/raw-json";

/**
 * `JSON.stringify` replacer that emits `bigint` values as raw JSON integers
 * (`{"range_min_timestamp_ns": 1719878400123456789}`). The default stringify
 * throws `TypeError` on bigint, and converting through `Number` would
 * silently round ns-epoch values past `Number.MAX_SAFE_INTEGER`.
 *
 * Write-side counterpart of `parseTimestampsAsBigInt`.
 *
 * https://github.com/tc39/proposal-json-parse-with-source
 */
export function bigintReplacer(_key: string, value: unknown): unknown {
  return typeof value === "bigint" ? rawJSON(value.toString()) : value;
}
